<template>
  <el-dialog
    :title="order?'订单已生成，请支付':'需购买课程后才可观看视频'"
    :visible.sync="dialogVisible"
    width="827px"
    :before-close="close"
    class="course_payment"
  >
  <!--  -->
    <!-- 已生成订单 -->
    <el-table class="course_table" :data="tableData" style="width: 100%" v-if="order">
      <el-table-column label="课程名称">
        <template slot-scope="scope">
          <div class="class_first">
            <img :src="scope.row.coverPath" />
            <p>{{scope.row.name}}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="code" label="订单号" width="200"></el-table-column>
      <el-table-column label="应付款" width="120">
        <template slot-scope="scope">
          <span>￥{{scope.row.money}}</span>
        </template>
      </el-table-column>
      <el-table-column label="实付款" width="120">
        <template slot-scope="scope">
          <span style="color:#FF743C;">￥{{scope.row.pay_money}}</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 未生成订单 -->
    <el-table class="course_table" :data="courseDetail" style="width: 100%" v-else>
      <el-table-column label="课程名称">
        <template slot-scope="scope">
          <div class="class_first">
            <img :src="scope.row.coverPath" />
            <p>{{scope.row.name}}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="有效期" width="200">
        <template slot-scope="scope">
          <span>一年</span>
        </template>
      </el-table-column>
      <el-table-column label="应付款" width="120">
        <template slot-scope="scope">
          <span>￥{{scope.row.money}}</span>
        </template>
      </el-table-column>
      <el-table-column label="实付款" width="120">
        <template slot-scope="scope">
          <span style="color:#FF743C;">￥{{scope.row.discount_money || scope.row.pay_money}}</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 已生成订单 并且 价格大于0 -->
    <div class="pay_box" v-if="order && order.pay_money > 0">
      <div class="pay_box_money">
        实付款:
        <span>￥{{order.pay_money}}</span>
      </div>
      <div class="pay_code">
        <!-- 支付成功提示 -->
        <div class="pay_succ" v-if="status==='ServiceOrderStatusComplete'">
          <i class="el-icon-success"></i>
          <p>支付成功</p>
        </div>
        <!-- 支付二维码 -->
        <div id="qrcode" ref="qrcode"></div>
      </div>
      <div class="pay_type" v-if="pay_type===20">
        <img src="@/assets/img/school/zfb.png" />使用支付宝支付
      </div>
      <div class="pay_type" v-else-if="pay_type===10">
        <img src="@/assets/img/school/wx.png" />使用微信支付
      </div>
      <template>
        <div class="change_pay_type" v-if="pay_type===20" @click="changePayType(10)">
          <i class="el-icon-refresh"></i>切换到微信支付
        </div>
        <div class="change_pay_type" v-else-if="pay_type===10"  @click="changePayType(20)">
          <i class="el-icon-refresh"></i>切换到支付宝支付
        </div>
      </template>
    </div>
    <!-- 未生成订单 -->
    <span slot="footer" class="dialog-footer" v-if="!order">
      <!-- 课程售价0 -->
      <template v-if="parseInt(courseDetail[0].discount_money) <=0">
        <el-button type="primary" @click="onestop(true)">立即购买</el-button>
      </template>
      <!-- 价格大于0 -->
      <template v-else>
        <el-button type="primary" @click="onestop">立即购买</el-button>
      </template>
    </span>
  </el-dialog>
</template>

<script>
import QRCode from "qrcodejs2";
import api from "@/api/api";
export default {
  props: {
    dialogVisible: {
      type: Boolean
    },
    //课程详情
    courseDetail: {
      type: Array
    }
  },
  data() {
    return {
      tableData: [],
      order: null, //订单详情
      pay_type: 20, //支付状态 支付宝：20 微信：10
      timer: null, //定时器轮询支付状态
      status: "",//支付状态
      qrcodeObj:null,//二维码生成对象
    };
  },
  mounted() {
    this.getOrders().then(res=>{
      if(res.obj.list[0] && res.obj.list[0]['pay_money']>0){
        this.pay();
      }
    });
  },
  methods: {
    /* 获取订单信息 */
    getOrders() {
      return new Promise(resolve => {
        let params = {
          user_id: sessionStorage.getItem("user_id"),
          entity_code: this.courseDetail[0].code,
          certificationType: "CertificationTypeInnovate",
          type: "ServiceTypeCOClass",
          status: "ServiceOrderStatusOnlinePay" //防止一个商品多个订单出现在列表
        };
        return this.api.getOrders(params, true).then(
          res => {
            if (res.error.err_code !== 0) return;
            this.tableData = res.obj.list;
            this.order = res.obj.list[0] || null;
            resolve(res);
          }
        );
      });
    },
    // 没有未支付订单时生成订单
    submitCOOrder() {
      let params = {
        name: this.courseDetail[0].name,
        entity_code: this.$route.query.code,
        money: this.courseDetail[0].money,
        pay_money: this.courseDetail[0].discount_money,
        nature_type: this.courseDetail[0].nature_type,
        operation: "ServiceOrderStatusOnlinePay"
        // pay_type: 20 //微信：10，支付宝：20
      };
      return new Promise(resolve => {
        this.api.submitCOOrder(params, true).then(res => {
          if (res.error["err_code"] === 0) {
            this.$message({
              type: "success",
              message: "生成订单!"
            });
            this.$parent.getFrontColleges(); //获取课程详情
            // this.$bus.$emit("paymentDialog", true); //订单弹窗（详情页接收）
            this.order = true; //改变订单状态，改变界面
            resolve();
          }
        });
      });
    },
    // 切换支付方式
    changePayType(pay_type) {
      this.pay_type = pay_type;
      this.pay();
    },
    // 一条龙操作
    async onestop() {
      await this.submitCOOrder();//生成订单
      await this.getOrders();//查询订单
      await this.pay();//支付0元订单，不为0元 生成二维码
    },
    /**
     * 0元支付或生成支付二维码
     * @param pay_type 支付方式 微信：10  支付宝：20
     * */
    pay() {
      if (!this.order) {
        this.$message.error("没有查询到订单信息！");
        return;
      }
      let params = {
        code: this.order.code,
        pay_type: this.pay_type
      };
      return new Promise(resovle => {
        this.api.pay(params, true).then(res => {
          if (res.error["err_code"] !== 0) return;
          console.log(this.order.pay_money)
          // 价格大于0生成二维码
          if (this.order.pay_money > 0) {
            console.log(res.obj.qr)
            this.qrcode(res.obj.qr); //二维码生成
            this.search();
          } else {
            this.$message({
              type: "success",
              message: "购买成功!"
            });
            this.close();
          }
          resovle();
        });
      });
    },
    // 轮询支付状态
    search() {
      clearInterval(this.timer);
      this.timer = setInterval(res => {
        this.getPayStatus().then(res => {
          this.status = res.status;
          // 支付成功
          if (res.status === "ServiceOrderStatusComplete") {
            clearInterval(this.timer);
            this.$message({
              type: "success",
              message: "支付成功!"
            });
            this.close();
          }
        });
      }, 3000);
    },
    // 查询支付状态
    getPayStatus() {
      return new Promise(resolve => {
        let params = {
          code: this.order.code
        };
        this.api.getPayStatus(params, false, false).then(
          res => {
            if (res.error["err_code"] !== 0) return;
            resolve(res);
          }
        );
      });
    },
    // 生产二维码
    qrcode(_url) {
      if(this.qrcodeObj){
         this.qrcodeObj.clear();
         this.qrcodeObj.makeCode(_url);
         return
      }
     
      this.qrcodeObj = new QRCode("qrcode", {
        width: 140,
        height: 140, // 高度
        text: _url, // 二维码内容
        render: "canvas" // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // background: '#f0f',
        // foreground: '#ff0'
      });
      console.log(this.qrcodeObj)
    },
    close() {
      clearInterval(this.timer);
      this.$emit("close", {
        name: "order_payment",
        dialogVisible: false
      });
    }
  }
};
</script>

<style lang="scss">
.course_payment {
  .course_table {
    border: 1px solid rgba(229, 233, 237, 1);
    .el-table__header-wrapper tr th {
      background: rgba(245, 246, 250, 1);
    }
    .class_first {
      display: flex;
      align-items: center;
      padding: 20px 0 20px 20px;
      img {
        width: 70px;
        height: 70px;
        border-radius: 2px;
      }
      p {
        font-size: 14px;
        color: rgba(76, 80, 98, 1);
        margin-left: 13px;
        width: 195px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
  }
  .pay_box {
    display: flex;
    flex-direction: column;
    align-items: center;
    .pay_box_money {
      height: 52px;
      line-height: 52px;
      font-size: 14px;
      color: #4b5062;
      span {
        color: #ff733c;
      }
    }
    .pay_code {
      width: 140px;
      height: 140px;
      border: 1px solid #02aaef;
      position: relative;
      .pay_succ {
        width: 140px;
        height: 140px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background: rgba(0, 0, 0, 0.7);
        position: absolute;
        z-index: 11;
        color: #fff;
        i {
          font-size: 40px;
          margin-bottom: 10px;
        }
      }
    }
    .pay_type {
      font-size: 14px;
      color: #4b5062;
      height: 46px;
      display: flex;
      align-items: center;
      img {
        margin-right: 8px;
      }
    }
    .change_pay_type {
      width: 100%;
      text-align: right;
      cursor: pointer;
      i {
        margin-right: 8px;
      }
      font-size: 14px;
      color: #3282ff;
    }
  }
}
</style>